export const COPIED_TO_CLIPBOARD_LINK_TOAST_ID = 'COPIED_TO_CLIPBOARD_LINK_TOAST_ID' as const;
export const REFERRAL_REF_CODE_ATTRIBUTE = 'refcode' as const;
export const PAGE_SIZE_REFERRALS = 10 as const;

export const REFERRAL_USERS_STATUSES = {
    REGISTERED: 'registered',
    DONE: 'done'
} as const;

export const REFERRAL_DISPLAY_FOR_TYPE = {
    REFERRAL: 'REFERRAL',
    REFERRER: 'REFERRER'
} as const;

export const REFERRAL_STATUS_TYPE = {
    DONE: 'DONE',
    USE_RESPAWN: 'USE_RESPAWN',
    REGISTERED: 'REGISTERED',
    TRADING: 'TRADING'
}